import {
  Box,
  Card,
  CardBody,
  Center,
  Heading,
  Icon,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FaPlay, FaTrash } from "react-icons/fa6";
import { ManualVideoModel } from "../../services";

export default function VideoCard({ data, fetchVideos }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const onDeleteVideo = async () => {
    try {
      setLoading(true);
      await ManualVideoModel.delete(data._id);
      onClose();
      fetchVideos();
      toast({
        description: "Video deleted successfully!",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card cursor="pointer" onClick={onOpen}>
        <CardBody p={3}>
          <Box position="relative">
            <IconButton
              icon={<FaTrash />}
              position="absolute"
              top={1}
              right={1}
              bgColor="white"
              color="red"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteVideo();
              }}
              isLoading={loading}
            />
            <Image
              src={`https://img.youtube.com/vi/${
                data.url.split("v=")[1]
              }/0.jpg`}
              aspectRatio="16/9"
              objectFit="cover"
              rounded="lg"
              alt=""
            />
            <Center
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              bgColor="whiteAlpha.400"
              p={4}
              rounded="full"
            >
              <Icon as={FaPlay} color="white" fontSize="2xl" />
            </Center>
          </Box>
          <Heading as="h4" fontSize="base" mt={2}>
            {data.title}
          </Heading>
        </CardBody>
      </Card>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Video</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <iframe
              src={`https://www.youtube.com/embed/${data.url.split("v=")[1]}`}
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              width="100%"
              style={{ aspectRatio: "16/9" }}
              allowfullscreen
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
